import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Urls } from 'shared/constants/urls';
import { classNames } from 'shared/utils/class-names';
import { Text } from 'shared/components/Text';
import classes from './styles.module.scss';
import { useSelector } from 'react-redux';
import { getAffiliateSelector } from 'store/settings/settings.redux';
import { eCommercePlatforms } from 'shared/constants/journeyTemplate';

interface ICustomLink {
  children: string;
  href: string;
}

const CustomLink: FC<ICustomLink> = ({ children, href }) => {
  const path = window.location.pathname;
  const isActive = href === '/' ? path === href : path.includes(href);
  return (
    <Link to={href}>
      <Text
        className={classNames({
          [classes.navigation__link]: true,
          [classes.navigation__active]: isActive
        })}
        type={path === href ? 'm-body-emphasized' : 'sf-body-medium'}
      >
        {children}
      </Text>
    </Link>
  );
};

const Navigation = () => {
  const affiliate = useSelector(getAffiliateSelector);
  const checkEcommerceModule =
    affiliate?.ecommerceModuleEnabled &&
    affiliate?.ecommercePlatform === eCommercePlatforms.TELEGRA_COMMERCE;
  return (
    <div className={classes.navigation}>
      <CustomLink href="/">Home</CustomLink>
      <CustomLink href={Urls.OrdersPage}>Orders</CustomLink>
      <CustomLink href={Urls.LabOrdersPage}>Lab Orders</CustomLink>
      <CustomLink href={Urls.PatientsPage}>Patients</CustomLink>
      <CustomLink href={Urls.ConsultationsPage}>Consultations</CustomLink>
      {affiliate?.affiliateChatSystem && (
        <CustomLink href={Urls.Messages}>Messages</CustomLink>
      )}
      {checkEcommerceModule && (
        <>
          <CustomLink href={Urls.JourneyTemplatePage}>
            Journey Template
          </CustomLink>
          <CustomLink href={Urls.ProductsPage}>Products</CustomLink>
          <CustomLink href={Urls.SubscriptionsPage}>Subscription</CustomLink>
          <CustomLink href={Urls.EcommerceOrdersPage}>
            Ecommerce Orders
          </CustomLink>
          <CustomLink href={Urls.CouponsPage}>Coupons</CustomLink>
        </>
      )}

      {/*
      <CustomLink href="/events">Events</CustomLink>
      <CustomLink href="/reports">Reports</CustomLink>
      */}
    </div>
  );
};

export default Navigation;
